import React, { Component, Suspense } from "react";
import { Provider } from "react-redux";
import { Router } from "react-router-dom";
import { NotificationContainer } from "react-notifications";
import store from "./store/configureStore";
import history from "./history";
import Routes from "./Routes";
import MinimizeDialogComponent from "./components/DialogWebrtc/MinimizeDialogComponent";
import { DialogProvider } from "./components/DialogWebrtc/DialogContext";
import { loginUser } from "./components/Login/authUtils";
import { Role } from "./Roles";
import "../node_modules/react-notifications/lib/notifications.css";

const { REACT_APP_BASE_NAME } = process.env;

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      role: "",
    };
  }

  componentDidMount() {
    this.updateUserRole();
    this.roleUpdateInterval = setInterval(this.updateUserRole, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.roleUpdateInterval);
  }

  updateUserRole = () => {
    const role = loginUser();
    if (role?.name !== this.state.role?.name) {
      this.setState({ role });
    }
  };

  render() {
    const { role } = this.state;

    return (
      <div className="App">
        <Suspense fallback={<div>Loading...</div>}>
          <NotificationContainer />
          <Provider store={store}>
            <DialogProvider>
              <Router basename={REACT_APP_BASE_NAME} history={history}>
                <Routes />
              </Router>
              {role?.name === Role.CRM_TELECALLER && (
                <MinimizeDialogComponent />
              )}
            </DialogProvider>
          </Provider>
        </Suspense>
      </div>
    );
  }
}

export default App;
